// Store exports
export { useAuthStore } from './model/auth.store';
export type { AuthState } from './model/auth.store';
export type { User } from '@/types/user';

// Selector exports (User lives in TanStack Query — read via these)
export {
  useUser,
  useToken,
  useIsAuthenticated,
  useIsInitialized,
  useAuthLoading,
  useLoginLoading,
  useRegisterLoading,
  useLogoutLoading,
  useHasError,
  useAuthError,
  useLoginError,
  useRegisterError,
  useUserProfile,
  useAuthState,
  useAuthActions,
  useIsEmailVerified,
  usePendingEmailVerification,
} from './model/auth.selectors';

// UI exports
export { LoginForm } from './ui/LoginForm';
export { RegisterForm } from './ui/RegisterForm';

// API exports
export { authService } from './api/auth';
export { userService } from './api/user.service';
export { authMethodsService } from './api/auth-methods.service';
